export default __webpack_public_path__ + "static/media/pointmassage_work.94349c53.jpg";